import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-950/95 backdrop-blur-md shadow-lg shadow-black/20'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <i className="ri-movie-2-line text-primary-400 text-2xl"></i>
            <span className="text-xl font-bold text-white tracking-wide font-heading">夜猫电影院</span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-400'
                  : 'text-foreground-300 hover:text-primary-400'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="flex items-center gap-1 text-sm font-medium text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                分类浏览
                <i className="ri-arrow-down-s-line text-base"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-900 border border-background-700/50 rounded-lg py-2 px-1 min-w-[200px] shadow-xl shadow-black/30">
                  <div className="grid grid-cols-2 gap-1">
                    {categories.slice(0, 8).map((cat) => (
                      <Link
                        key={cat.id}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-300 hover:text-primary-400 hover:bg-background-800 transition-colors duration-150 whitespace-nowrap"
                      >
                        <i className={`${cat.icon} text-base`}></i>
                        {cat.name}
                      </Link>
                    ))}
                    <Link
                      to="/category/hot"
                      className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-primary-400 hover:bg-background-800 transition-colors duration-150 whitespace-nowrap col-span-2"
                    >
                      <i className="ri-apps-line text-base"></i>
                      查看全部分类
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-400'
                  : 'text-foreground-300 hover:text-primary-400'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-md border-t border-background-800/50">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm text-foreground-300 hover:text-primary-400 hover:bg-background-800/50 transition-colors">
              <i className="ri-home-line text-lg"></i> 首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm text-foreground-300 hover:text-primary-400 hover:bg-background-800/50 transition-colors"
              >
                <i className={`${cat.icon} text-lg`}></i> {cat.name}
              </Link>
            ))}
            <Link to="/about" className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm text-foreground-300 hover:text-primary-400 hover:bg-background-800/50 transition-colors">
              <i className="ri-information-line text-lg"></i> 关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}